enum PrintSettingsElementEnum {
  HeaderColor = "headerColor",
  ShadingColor = "shadingColor",
}

export { PrintSettingsElementEnum };
